import $ from 'jquery'

const COUNT_NODE_SELECTOR = '.form-control__counter-count'
const TOTAL_NODE_SELECTOR = '.form-control__counter-total'

class TextInputCounters {
  constructor(selector = '.form-control--has-counter') {
    this.items = $(selector)

    this.init()
  }

  init() {
    this.items.each((index, item) => new TextInputCounter(item))
  }
}

class TextInputCounter {
  constructor(el) {
    this.input = $(el)
    this.parent = $(el).parent()
    this.counter = $(COUNT_NODE_SELECTOR, this.parent)
    this.total = $(TOTAL_NODE_SELECTOR, this.parent)

    this.currentCount = this.input.val().length || 0
    this.maxCount = this.input.attr('maxlength')

    this.init()
  }

  init() {
    this.setInitialCount()
    this.listen()
  }

  listen() {
    this.input.on('input', this.onInputChanged.bind(this))
  }

  onInputChanged(e) {
    this.currentCount = e.target.value.length || 0
    this.setCount(this.currentCount)
  }

  setInitialCount() {
    this.counter.text(this.currentCount)
    this.total.text(this.maxCount)
  }

  setCount(count) {
    this.counter.text(count)
  }
}

export default TextInputCounters
